export default __webpack_public_path__ + "static/media/india_map.240c0d69.png";